import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Radio,
  Space,
  Checkbox,
  message,
  Spin,
  Input,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import { RESEARCH_TYPE } from "../../../../utils/consts";
import dayjs from "dayjs";
import moment from "moment";
const { TextArea } = Input;

const { Option } = Select;

export default class MedicalHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smoking_history: "",
      allergies: [
        {
          id: 1,
          name: "",
        },
      ],
      prescriptions: [
        {
          id: 1,
          name: "",
          dose: "",
          frequency: "",
          frequency_type: "",
          date_started: "",
          reason: "",
          units: "",
          unit_type: "",
          route: "",
          route_type: "",
        },
      ],
      surgeries: [
        {
          id: 1,
          type: "",
          location: "",
          date: "",
        },
      ],
      diagnosed_hair_loss: "",
      anything_apply_to_you: [],
      loading: false,
      have_you_quit_smoking_in_the_past_year: "",
      do_you_have_allergies: "",
      // history
      bipolar_disorder: "",
      brain_aneurysm: "",
      cancer: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscle_disease: "",
      schizophrenia: "",
      migraines: "",

      adhd: "",
      anxiety: "",
      asthma: "",
      autism_spectrum_disorder: "",
      cognitive_impairment: "",
      concussion: "",
      copd: "",
      dementia: "",
      other_history_option: "",
      other_history_specification: "",

      participant_type: [],
      participant_type_als: "",
      participant_type_any_other_neurologic_diagnosis: "",
      participant_type_any_other_neurologic_diagnosis_other_specification: "",

      ecas_user_type: "",
      do_you_have_surgeries: "",
      do_you_have_prescription: "",

      enrolled_in_other_trials: "",
      trial_name: "",
      trial_description: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "ALS Drug History") {
                this.setState({ als_drug_history: item.value });
              }
              if (
                item.field ==
                "Currently Enrolled in other interventional clinical trials"
              ) {
                this.setState({ enrolled_in_other_trials: item.value });
              }
              if (
                item.field ==
                "Currently Enrolled in other interventional clinical trials - Trial Name"
              ) {
                this.setState({ trial_name: item.value });
              }
              if (
                item.field ==
                "Currently Enrolled in other interventional clinical trials - Trial Description"
              ) {
                this.setState({ trial_description: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.als_drug_history) {
      message.warning("ALS drug history is required");
      return;
    }
    if (!this.state.enrolled_in_other_trials) {
      message.warning(
        "Currently Enrolled in Other Interventional Clinical Trials field is required"
      );
      return;
    }
    if (this.state.enrolled_in_other_trials == "yes") {
      if (!this.state.trial_name) {
        message.warning("Trial name is required");
        return;
      }
      if (!this.state.trial_description) {
        message.warning("Trial description is required");
        return;
      }
    }
    let questions = [
      {
        parent_field: "ALS Drug History",
        field: "ALS Drug History",
        value: this.state.als_drug_history,
      },
      {
        parent_field:
          "Currently Enrolled in other interventional clinical trials",
        field: "Currently Enrolled in other interventional clinical trials",
        value: this.state.enrolled_in_other_trials,
      },
      {
        parent_field:
          "Currently Enrolled in other interventional clinical trials - Trial Name",
        field:
          "Currently Enrolled in other interventional clinical trials -Trial Name",
        value: this.state.trial_name,
      },
      {
        parent_field:
          "Currently Enrolled in other interventional clinical trials - Trial Description",
        field:
          "Currently Enrolled in other interventional clinical trials - Trial Description",
        value: this.state.trial_description,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "5",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                setTimeout(() => {
                  window.location.assign("/dashboard");
                }, 3000);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };

  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    return (
      <div>
        <div className="header">
          <h3>MEDICAL HISTORY</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                ALS Drug History <span className="text-danger">*</span>
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    als_drug_history: value,
                  })
                }
                value={this.state.als_drug_history}
                className="col-lg-12"
                placeholder="Select ALS Drugs"
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                <Option value="">Select</Option>
                <Option value="riluzole">Riluzole</Option>
                <Option value="radicava">Radicava</Option>
                <Option value="high dose B12">High dose B12</Option>
                <Option value="qualsody">Qualsody</Option>
                <Option value="Clene">Clene</Option>
                <Option value="Prime C">Prime C</Option>
                <Option value="Nuedexta">Nuedexta</Option>
              </Select>
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Currently Enrolled in other interventional clinical
                  trials&nbsp; <span className="text-danger">*</span>
                </label>
              </div>
              <div className="form-group mt-3">
                <Radio.Group
                  onChange={(e) =>
                    this.setState({
                      enrolled_in_other_trials: e.target.value,
                      trial_name: "",
                      trial_description: "",
                    })
                  }
                  value={this.state.enrolled_in_other_trials}
                >
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>
              </div>

              {this.state.enrolled_in_other_trials === "yes" && (
                <div className="col-lg-10">
                  <div className="form-group mb-4 d-flex row pl-2 pl-sm-2 pl-md-0 pl-lg-0 pl-xl-0 pr-3">
                    <label className="input-heading">
                      Trial Name
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <div className="">
                      <Input
                        type="text"
                        value={this.state.trial_name}
                        onChange={(e) =>
                          this.setState({
                            trial_name: e.target.value,
                          })
                        }
                        placeholder="Enter Trial Name"
                        className="col-lg-12"
                      />
                    </div>
                  </div>
                  <div className="form-group mb-4 d-flex row pl-2 pl-sm-2 pl-md-0 pl-lg-0 pl-xl-0 pr-3">
                    <label className="input-heading">
                      Trial Description
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <div className="">
                      <Input.TextArea
                        value={this.state.trial_description}
                        onChange={(e) =>
                          this.setState({
                            trial_description: e.target.value,
                          })
                        }
                        placeholder="Enter Trial Description"
                        className="col-lg-12"
                        rows={3}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(4)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
